<template>
  <div
    class="checkbox-field"
    :class="[wrapperStyle.class]"
    :style="[wrapperStyle.style]"
    :ref="name.toLowerCase()"
  >
    <div>
      <label v-if="showLabel">{{ label }}</label>
    </div>

    <div>
      <p
        class="checkbox-wrapper"
        v-for="({ value, text }, index) in options"
        :key="index"
        :class="[getGrid()]"
      >
        <label>
          <input
            :id="getID(name, text)"
            type="checkbox"
            :disabled="isDisabled"
            class="filled-in"
            :value="value"
            v-model="fieldValue"
          />

          <span> &nbsp; </span>
        </label>
        <span v-html="text" class="checkbox-text"></span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckboxField",
  props: {
    value: {
      type: [Array],
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    // fieldType: {
    //   type: String,
    //   required: true,
    // },
    gridStyle: {
      type: [Object],
      default: () => ({}),
    },
    showLabel: {
      type: Boolean,
      default: true,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    options: {
      type: Array,
      required: true,
    },
    helperText: {
      type: String,
      required: false,
      default: "",
    },
    autoComplete: {
      type: Boolean,
      default: () => true,
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    fieldStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    icon: {
      type: String,
      required: false,
    },
    groupTag: {
      type: String,
      default: () => "",
    },
    error: {
      type: String,
      required: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      reuqired: false,
    },
  },
  data() {
    return {
      isTyping: false,
      fieldValue: this.value,
    };
  },
  mounted() {
    this.addToGroup();
  },
  watch: {
    fieldValue: function () {
      this.updateValue();
    },
  },
  computed: {
    displayError() {
      if (this.isTyping) {
        if (this.hasError && this.error) {
          return "invalid";
        } else {
          return "valid";
        }
      }
    },
  },
  methods: {
    test() {
      console.log("Jello");
    },
    addToGroup() {
      if (this.groupTag) {
        const groupId = `#${this.groupTag}`;
        // console.log(`${this.name} => belongs to ${this.groupTag} group`);

        const group = document.querySelector(groupId);
        const groupItem = this.$refs[this.name.toLowerCase()];
        group.appendChild(groupItem);
      }
    },
    updateValue(event) {
      // console.log(error, hasError);
      // console.log(this.fieldValue);
      this.$emit("update", this.fieldValue);
    },

    getGrid() {
      if (!this.gridStyle.grid) {
        return this.options.length > 4 ? "col s3" : "col s6";
      } else {
        return this.gridStyle.grid;
      }
    },
    getID(name, text) {
      let newString = text.toLowerCase().replace(/[^A-Z0-9]+/gi, "_");

      return `${name}_${newString}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-field {
  .checkbox-wrapper {
    display: flex;
  }
}
</style>